import { memo, MouseEvent, RefObject, useCallback } from 'react'
import clsx from 'clsx'
import { IconButton, Stack, SxProps } from '@mui/material'
import { Box } from '@/components/Layout'
import { LeftArrow, RightArrow } from '@/assets'
import { swiperClasses } from '../Swiper.data'
import { swiperStyles as styles } from './SwiperButtons.style'

interface SwiperButtonsProps {
  isBeginning: boolean
  isEnd: boolean
  navigationPrevButtonRef: RefObject<HTMLButtonElement | null>
  navigationNextButtonRef: RefObject<HTMLButtonElement | null>
  showNavigationButton?: boolean
}

function SwiperButtons({
  isBeginning,
  isEnd,
  navigationPrevButtonRef,
  navigationNextButtonRef,
  showNavigationButton = true,
}: SwiperButtonsProps) {
  const onNext = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
  }, [])

  const onPrevious = useCallback((event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
  }, [])

  return (
    <Stack
      direction="row"
      sx={
        {
          ...styles.swiperButtonWrapper,
          ...(showNavigationButton ? styles.shouldShowSwiperButton : styles.shouldHideSwiperButton),
        } as SxProps
      }>
      <Box sx={styles.buttonWrapper}>
        <IconButton
          ref={navigationPrevButtonRef}
          className={clsx(swiperClasses.swiperTopButton, swiperClasses.swiperTopButtonPrev)}
          size="large"
          sx={styles.arrowButton?.(isBeginning)}
          disabled={isBeginning}
          onClick={onPrevious}>
          <Box sx={styles.arrowIconBox}>
            <Box sx={styles.arrowIcon} component={LeftArrow} />
          </Box>
        </IconButton>
        <IconButton
          ref={navigationNextButtonRef}
          className={clsx(swiperClasses.swiperTopButton, swiperClasses.swiperTopButtonNext)}
          size="large"
          sx={styles.arrowButton?.(isEnd)}
          disabled={isEnd}
          onClick={onNext}>
          <Box sx={styles.arrowIconBox}>
            <Box sx={styles.arrowIcon} component={RightArrow} />
          </Box>
        </IconButton>
      </Box>
    </Stack>
  )
}

export default memo(SwiperButtons)
